module.exports = __webpack_public_path__ + "static/media/test image.05a0f378.png";